import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _to_property_key } from "@swc/helpers/_/_to_property_key";
import { ALLOWED_BILLED_UPON } from '~/types/api/drafts-search';
import { discountExpirationKind, hasDiscountExpirationContent } from './serviceDiscountExpiration';
import { selectedServiceNames } from './serviceName';
const compact = (predicate)=>Object.keys(predicate).length === 0 ? undefined : predicate;
const EXISTENCE_BOUND = '0';
export const PREAPPROVED_AMOUNT_EXISTENCE = {
    gt: EXISTENCE_BOUND
};
export const isBareExistenceBound = (range)=>(range.gt == null || range.gt === EXISTENCE_BOUND) && range.gte == null && range.lt == null && range.lte == null && range.eq == null && range.neq == null;
export const isBarePreapprovedExistence = isBareExistenceBound;
export const hasSetValues = (set)=>{
    var _ref, _ref1;
    var _set_in, _set_nin;
    return set != null && (((_ref = (_set_in = set.in) === null || _set_in === void 0 ? void 0 : _set_in.length) !== null && _ref !== void 0 ? _ref : 0) > 0 || ((_ref1 = (_set_nin = set.nin) === null || _set_nin === void 0 ? void 0 : _set_nin.length) !== null && _ref1 !== void 0 ? _ref1 : 0) > 0);
};
const nonEmptySet = (set)=>hasSetValues(set) ? set : undefined;
export const setToCheckboxes = (predicate)=>{
    var _predicate_in;
    return predicate.nin != null ? {
        selected: predicate.nin,
        operator: 'exclude'
    } : {
        selected: (_predicate_in = predicate.in) !== null && _predicate_in !== void 0 ? _predicate_in : [],
        operator: 'include'
    };
};
export const checkboxesToSet = (next)=>next.operator === 'exclude' ? {
        nin: [
            ...next.selected
        ]
    } : {
        in: [
            ...next.selected
        ]
    };
export const rebuildSetField = (predicate, field, value)=>{
    const { [field]: _omit } = predicate, rest = _object_without_properties(predicate, [
        _to_property_key(field)
    ]);
    const kept = nonEmptySet(value);
    return compact(kept == null ? rest : _object_spread_props(_object_spread({}, rest), {
        [field]: kept
    }));
};
export const rebuildDecimalField = (predicate, field, value)=>{
    const { [field]: _omit } = predicate, rest = _object_without_properties(predicate, [
        _to_property_key(field)
    ]);
    return compact(value == null ? rest : _object_spread_props(_object_spread({}, rest), {
        [field]: value
    }));
};
const buildDiscount = (type, amount, expiration)=>{
    const discount = {};
    if (type != null) discount.type = type;
    if (amount != null) discount.amount = amount;
    if (expiration != null) discount.expiration = expiration;
    return Object.keys(discount).length === 0 ? undefined : discount;
};
const rebuildDiscount = (predicate, discount)=>{
    const { discount: _omit } = predicate, rest = _object_without_properties(predicate, [
        "discount"
    ]);
    return compact(discount == null ? rest : _object_spread_props(_object_spread({}, rest), {
        discount
    }));
};
export const rebuildDiscountType = (predicate, value)=>{
    var _predicate_discount, _predicate_discount1;
    return rebuildDiscount(predicate, buildDiscount(nonEmptySet(value), (_predicate_discount = predicate.discount) === null || _predicate_discount === void 0 ? void 0 : _predicate_discount.amount, (_predicate_discount1 = predicate.discount) === null || _predicate_discount1 === void 0 ? void 0 : _predicate_discount1.expiration));
};
export const rebuildDiscountAmount = (predicate, value)=>{
    var _predicate_discount, _predicate_discount1;
    return rebuildDiscount(predicate, buildDiscount((_predicate_discount = predicate.discount) === null || _predicate_discount === void 0 ? void 0 : _predicate_discount.type, value, (_predicate_discount1 = predicate.discount) === null || _predicate_discount1 === void 0 ? void 0 : _predicate_discount1.expiration));
};
const buildDiscountExpiration = (type, date)=>{
    const expiration = {};
    if (type != null) expiration.type = type;
    if (date != null) expiration.date = date;
    return Object.keys(expiration).length === 0 ? undefined : expiration;
};
const rebuildDiscountExpiration = (predicate, expiration)=>{
    var _predicate_discount, _predicate_discount1;
    return rebuildDiscount(predicate, buildDiscount((_predicate_discount = predicate.discount) === null || _predicate_discount === void 0 ? void 0 : _predicate_discount.type, (_predicate_discount1 = predicate.discount) === null || _predicate_discount1 === void 0 ? void 0 : _predicate_discount1.amount, expiration));
};
export const removeDiscountExpirationType = (predicate)=>{
    var _predicate_discount_expiration, _predicate_discount;
    return rebuildDiscountExpiration(predicate, buildDiscountExpiration(undefined, (_predicate_discount = predicate.discount) === null || _predicate_discount === void 0 ? void 0 : (_predicate_discount_expiration = _predicate_discount.expiration) === null || _predicate_discount_expiration === void 0 ? void 0 : _predicate_discount_expiration.date));
};
export const rebuildDiscountExpirationDate = (predicate, date)=>{
    var _predicate_discount_expiration, _predicate_discount;
    return rebuildDiscountExpiration(predicate, buildDiscountExpiration((_predicate_discount = predicate.discount) === null || _predicate_discount === void 0 ? void 0 : (_predicate_discount_expiration = _predicate_discount.expiration) === null || _predicate_discount_expiration === void 0 ? void 0 : _predicate_discount_expiration.type, date));
};
const buildPriceIncrease = (exists, percent, start)=>{
    const priceIncrease = {};
    if (exists != null) priceIncrease.exists = exists;
    if (percent != null) priceIncrease.percent = percent;
    if (start.startOnType != null) priceIncrease.startOnType = start.startOnType;
    if (start.startOn != null) priceIncrease.startOn = start.startOn;
    return Object.keys(priceIncrease).length === 0 ? undefined : priceIncrease;
};
const currentStart = (predicate)=>{
    var _predicate_priceIncrease, _predicate_priceIncrease1;
    return {
        startOnType: (_predicate_priceIncrease = predicate.priceIncrease) === null || _predicate_priceIncrease === void 0 ? void 0 : _predicate_priceIncrease.startOnType,
        startOn: (_predicate_priceIncrease1 = predicate.priceIncrease) === null || _predicate_priceIncrease1 === void 0 ? void 0 : _predicate_priceIncrease1.startOn
    };
};
const rebuildPriceIncrease = (predicate, priceIncrease)=>{
    const { priceIncrease: _omit } = predicate, rest = _object_without_properties(predicate, [
        "priceIncrease"
    ]);
    return compact(priceIncrease == null ? rest : _object_spread_props(_object_spread({}, rest), {
        priceIncrease
    }));
};
export const rebuildPriceIncreasePercent = (predicate, value)=>{
    var _predicate_priceIncrease;
    return rebuildPriceIncrease(predicate, buildPriceIncrease((_predicate_priceIncrease = predicate.priceIncrease) === null || _predicate_priceIncrease === void 0 ? void 0 : _predicate_priceIncrease.exists, value, currentStart(predicate)));
};
export const rebuildPriceIncreaseStartOnType = (predicate, value)=>{
    var _predicate_priceIncrease, _predicate_priceIncrease1, _predicate_priceIncrease2;
    return rebuildPriceIncrease(predicate, buildPriceIncrease((_predicate_priceIncrease = predicate.priceIncrease) === null || _predicate_priceIncrease === void 0 ? void 0 : _predicate_priceIncrease.exists, (_predicate_priceIncrease1 = predicate.priceIncrease) === null || _predicate_priceIncrease1 === void 0 ? void 0 : _predicate_priceIncrease1.percent, {
        startOnType: nonEmptySet(value),
        startOn: (_predicate_priceIncrease2 = predicate.priceIncrease) === null || _predicate_priceIncrease2 === void 0 ? void 0 : _predicate_priceIncrease2.startOn
    }));
};
export const rebuildPriceIncreaseStart = (predicate, start)=>{
    var _predicate_priceIncrease, _predicate_priceIncrease1;
    return rebuildPriceIncrease(predicate, buildPriceIncrease((_predicate_priceIncrease = predicate.priceIncrease) === null || _predicate_priceIncrease === void 0 ? void 0 : _predicate_priceIncrease.exists, (_predicate_priceIncrease1 = predicate.priceIncrease) === null || _predicate_priceIncrease1 === void 0 ? void 0 : _predicate_priceIncrease1.percent, {
        startOnType: nonEmptySet(start === null || start === void 0 ? void 0 : start.startOnType),
        startOn: start === null || start === void 0 ? void 0 : start.startOn
    }));
};
export const rebuildPriceIncreaseExists = (predicate, value)=>{
    var _predicate_priceIncrease;
    return rebuildPriceIncrease(predicate, value === false ? buildPriceIncrease(false, undefined, {}) : buildPriceIncrease(value, (_predicate_priceIncrease = predicate.priceIncrease) === null || _predicate_priceIncrease === void 0 ? void 0 : _predicate_priceIncrease.percent, currentStart(predicate)));
};
export const rebuildLimitedTimeDiscount = (predicate, value)=>{
    const { limitedTimeDiscountOffer: _omit } = predicate, rest = _object_without_properties(predicate, [
        "limitedTimeDiscountOffer"
    ]);
    return compact(value == null ? rest : _object_spread_props(_object_spread({}, rest), {
        limitedTimeDiscountOffer: {
            exists: value
        }
    }));
};
const buildMaxCharges = (exists, limit)=>{
    const maxCharges = {};
    if (exists != null) maxCharges.exists = exists;
    if (limit != null) maxCharges.limit = limit;
    return Object.keys(maxCharges).length === 0 ? undefined : maxCharges;
};
const rebuildMaxCharges = (predicate, maxCharges)=>{
    const { maxCharges: _omit } = predicate, rest = _object_without_properties(predicate, [
        "maxCharges"
    ]);
    return compact(maxCharges == null ? rest : _object_spread_props(_object_spread({}, rest), {
        maxCharges
    }));
};
export const rebuildMaxChargesExists = (predicate, value)=>{
    var _predicate_maxCharges;
    return rebuildMaxCharges(predicate, value === false ? buildMaxCharges(false, undefined) : buildMaxCharges(value, (_predicate_maxCharges = predicate.maxCharges) === null || _predicate_maxCharges === void 0 ? void 0 : _predicate_maxCharges.limit));
};
export const rebuildMaxChargesLimit = (predicate, value)=>{
    var _predicate_maxCharges;
    return rebuildMaxCharges(predicate, buildMaxCharges((_predicate_maxCharges = predicate.maxCharges) === null || _predicate_maxCharges === void 0 ? void 0 : _predicate_maxCharges.exists, value));
};
export const rebuildBillUpfront = (predicate, value)=>{
    const { billUpfront: _omit } = predicate, rest = _object_without_properties(predicate, [
        "billUpfront"
    ]);
    return compact(value == null ? rest : _object_spread_props(_object_spread({}, rest), {
        billUpfront: value
    }));
};
export const rebuildDescription = (predicate, value)=>{
    const { description: _omit } = predicate, rest = _object_without_properties(predicate, [
        "description"
    ]);
    return compact(value == null ? rest : _object_spread_props(_object_spread({}, rest), {
        description: {
            exists: value
        }
    }));
};
const buildStartBillingAt = (exists, date)=>{
    const startBillingAt = {};
    if (exists != null) startBillingAt.exists = exists;
    if (date != null) startBillingAt.date = date;
    return Object.keys(startBillingAt).length === 0 ? undefined : startBillingAt;
};
const rebuildStartBillingAt = (predicate, startBillingAt)=>{
    const { startBillingAt: _omit } = predicate, rest = _object_without_properties(predicate, [
        "startBillingAt"
    ]);
    return compact(startBillingAt == null ? rest : _object_spread_props(_object_spread({}, rest), {
        startBillingAt
    }));
};
export const rebuildStartBillingAtExists = (predicate, value)=>{
    var _predicate_startBillingAt;
    return rebuildStartBillingAt(predicate, value === false ? buildStartBillingAt(false, undefined) : buildStartBillingAt(value, (_predicate_startBillingAt = predicate.startBillingAt) === null || _predicate_startBillingAt === void 0 ? void 0 : _predicate_startBillingAt.date));
};
export const rebuildStartBillingAtDate = (predicate, value)=>{
    var _predicate_startBillingAt;
    return rebuildStartBillingAt(predicate, buildStartBillingAt((_predicate_startBillingAt = predicate.startBillingAt) === null || _predicate_startBillingAt === void 0 ? void 0 : _predicate_startBillingAt.exists, value));
};
const isNameOnlyArm = (arm)=>Object.keys(arm).length === 1 && arm.name != null;
const hasDiscountContent = (discount)=>discount != null && (hasSetValues(discount.type) || discount.amount != null || hasDiscountExpirationContent(discount.expiration));
export const hasFlattenableContent = (predicate)=>{
    var _predicate_priceIncrease, _predicate_priceIncrease1, _predicate_priceIncrease2, _predicate_priceIncrease3, _predicate_limitedTimeDiscountOffer, _predicate_maxCharges, _predicate_maxCharges1, _predicate_description, _predicate_startBillingAt, _predicate_startBillingAt1;
    return selectedServiceNames(predicate).length > 0 || hasSetValues(predicate.recurrence) || hasSetValues(predicate.billedUpon) || hasSetValues(predicate.pricingType) || predicate.priceMin != null || predicate.priceMax != null || predicate.cap != null || hasDiscountContent(predicate.discount) || ((_predicate_priceIncrease = predicate.priceIncrease) === null || _predicate_priceIncrease === void 0 ? void 0 : _predicate_priceIncrease.percent) != null || ((_predicate_priceIncrease1 = predicate.priceIncrease) === null || _predicate_priceIncrease1 === void 0 ? void 0 : _predicate_priceIncrease1.exists) != null || hasSetValues((_predicate_priceIncrease2 = predicate.priceIncrease) === null || _predicate_priceIncrease2 === void 0 ? void 0 : _predicate_priceIncrease2.startOnType) || ((_predicate_priceIncrease3 = predicate.priceIncrease) === null || _predicate_priceIncrease3 === void 0 ? void 0 : _predicate_priceIncrease3.startOn) != null || ((_predicate_limitedTimeDiscountOffer = predicate.limitedTimeDiscountOffer) === null || _predicate_limitedTimeDiscountOffer === void 0 ? void 0 : _predicate_limitedTimeDiscountOffer.exists) != null || ((_predicate_maxCharges = predicate.maxCharges) === null || _predicate_maxCharges === void 0 ? void 0 : _predicate_maxCharges.exists) != null || ((_predicate_maxCharges1 = predicate.maxCharges) === null || _predicate_maxCharges1 === void 0 ? void 0 : _predicate_maxCharges1.limit) != null || predicate.billUpfront != null || ((_predicate_description = predicate.description) === null || _predicate_description === void 0 ? void 0 : _predicate_description.exists) != null || ((_predicate_startBillingAt = predicate.startBillingAt) === null || _predicate_startBillingAt === void 0 ? void 0 : _predicate_startBillingAt.exists) != null || ((_predicate_startBillingAt1 = predicate.startBillingAt) === null || _predicate_startBillingAt1 === void 0 ? void 0 : _predicate_startBillingAt1.date) != null;
};
const MAPPED_BILLED_UPON = new Set(ALLOWED_BILLED_UPON);
const hasUnmappedBilledUpon = (set)=>{
    var _ref;
    return ((_ref = set === null || set === void 0 ? void 0 : set.in) !== null && _ref !== void 0 ? _ref : []).some((value)=>!MAPPED_BILLED_UPON.has(value));
};
const hasUnmappedDiscountExpiration = (expiration)=>hasSetValues(expiration === null || expiration === void 0 ? void 0 : expiration.type) && discountExpirationKind(expiration) == null;
export const isFlattenableCondition = (predicate, quantifier)=>{
    var _ref, _predicate_or;
    var _predicate_billedUpon_nin, _predicate_billedUpon, _predicate_discount;
    if (quantifier !== 'any') return false;
    if (predicate.not != null) return false;
    if (((_ref = (_predicate_billedUpon = predicate.billedUpon) === null || _predicate_billedUpon === void 0 ? void 0 : (_predicate_billedUpon_nin = _predicate_billedUpon.nin) === null || _predicate_billedUpon_nin === void 0 ? void 0 : _predicate_billedUpon_nin.length) !== null && _ref !== void 0 ? _ref : 0) > 0) return false;
    if (hasUnmappedBilledUpon(predicate.billedUpon)) return false;
    if (hasUnmappedDiscountExpiration((_predicate_discount = predicate.discount) === null || _predicate_discount === void 0 ? void 0 : _predicate_discount.expiration)) return false;
    const orArms = (_predicate_or = predicate.or) !== null && _predicate_or !== void 0 ? _predicate_or : [];
    if (orArms.some((arm)=>!isNameOnlyArm(arm))) return false;
    if (predicate.name != null && orArms.some((arm)=>arm.name != null)) return false;
    return hasFlattenableContent(predicate);
};
